import { Environment } from '@thiememeulenhoff/types';
import { deployUrl } from './deploy-url';
import { ChannelsEnvironmentType } from './environment.type';

export const environment: ChannelsEnvironmentType = {
  environment: Environment.Production,
  production: true,
  deployUrl: deployUrl(),
  analytics: {
    tagManagerId: '',
    tagManagerAuth: '',
    tagManagerPreview: '',
  },
  thas: {
    environment: 'prod',
    token: '8ceb033cafb266dee4eda40f84e406d8ef9aebbdc0f7596510892388b8daacc3',
  },
  auth: {
    environment: Environment.Production,
    clientId: 'channels',
    clientSecret: '538bb4ef-ca0d-4623-8d08-fcfbd08dc932',
    useUserCookie: true,
  },
  unleash: {
    instance: 'eu.app.unleash-hosted.com/euee0007',
    clientKey:
      '*:production.5f8928ceb399f8c72cd7e889f7c11193ee173f652b5595c5c1a71d38',
    environment: 'production',
    refreshInterval: 5 * 60, // 5 minutes
    metricsInterval: 15 * 60, // 15 minutes
  },
};
